<template>
  <div class="Admin">
    <!-- <div class="clearfix" style="height:75px;border: 2px solid #13314f;background-color: #dee8f3;">
      <img alt="FFS logo" src="../assets/nsf4.gif" style="float: left;height: 100%;padding: 2px;" />
      <p
        style="float: left;margin: 0px;font-size: 16px;font-weight: bold;margin: 26px 0;"
      >National Science Foundation</p>
      <v-btn
        style="float: right;top: 50%;transform: translateY(-75%);"
        rounded
        color="blue-grey"
        class="white--text"
        @click="logout"
      >Logout</v-btn>
      <p
        style="float: right;margin: 0px;font-size: 16px;font-weight: bold;margin: 26px 13px 26px 0;"
      >Questionnairre v15</p>
    </div> -->
    <NavBarHome></NavBarHome>
    <br />
    <h1>{{form.formName}}</h1>

    <H3>Update Section:</H3>
    <br />
    <v-layout row wrap>
      <v-flex xs1>
        <v-text-field filled label="Survey Id: " v-model="form.surveyId"></v-text-field>
      </v-flex>
      <v-flex xs1>
        <v-text-field filled label="Section Id:" v-model="form.sectionId"></v-text-field>
      </v-flex>
      <v-flex xs7>
        <v-text-field
          filled
          label="Section Json: "
          v-model="form.json"
        
        ></v-text-field>
      </v-flex>
      <v-flex xs1>
        <div class="clearfix buttons-container">
          <v-btn class="button" rounded color="primary" dark v-on:click="getSection">Get Section</v-btn>
        </div>
      </v-flex>
      
 

      <v-flex xs1>
        <div class="clearfix buttons-container">
          <v-btn class="button" rounded color="primary" dark v-on:click="Submit">Update</v-btn>
        </div>
      </v-flex>

                 <v-flex xs1>
        <div class="clearfix buttons-container">
          <v-btn class="button" rounded color="primary" dark v-on:click="deleteSection">Delete</v-btn>
        </div>
      </v-flex>

    </v-layout>

    <br />

    <transition name="fade" mode="out-in">
      <article class="message is-primary" v-show="showSubmitFeedback">
        <div class="message-header">
          <p>Send Status:</p>
        </div>
        <div class="message-body">Successfully Submitted!</div>
      </article>
    </transition>

    <hr />

    <h5>JSON</h5>
    <pre style="text-align: left; overflow-x: auto;"><code>{{form.json}}</code></pre>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import { authTokenService } from "@/services/authTokenService.js";
import { surveyService } from "@/services/surveyService.js";
import { authService } from "@/services/authService.js";
import { CONSTANTS } from "../common/constants";
import { adminService } from "../services/adminService";
import { NavBarHome } from "@/components/NavBarHome.vue";
import router from "@/router";

export default {
  name: "Admin",
  components: {},
  data: () => ({
    form: {
      formName: "Admin Page",
      surveyId: null,
      sectionId: null,
      json: null,
    },
    showSubmitFeedback: false,
    results: null
  }),
  methods: {
    logout() {
      authService.logout();
    },
    Submit() {
      this.showSubmitFeedback = true;
      setTimeout(() => {
        this.showSubmitFeedback = false;
      }, 3000);
      const s = adminService
        .updateSection(this.form.surveyId, this.form.sectionId, this.form.json)
        .then(function(response) {
          if (response && CONSTANTS.HTTP.NO_CONTENT === response.status) {
            // 204 - Success No Content
            console.log("Called save with: ");
            // me.$store.commit("save", {
            //   value: me.answer,
            //   id: me.question.displayId
            // });
          }
        })
        .catch(function(e) {
          console.error(e);
          throw e;
        });
    },
    getSection() {
      const me = this;
      this.showSubmitFeedback = true;
      setTimeout(() => {
        this.showSubmitFeedback = false;
      }, 3000);
      const s = adminService
        .getSection(this.form.surveyId, this.form.sectionId)
        .then(function(response) {
          if (response && response.data){
            me.form.json = JSON.stringify(response.data, null, 2); 
          }
          
        })
        .catch(function(e) {
          console.error(e);
          throw e;
        });
    },
    deleteSection() {
      const me = this;
      this.showSubmitFeedback = true;
      setTimeout(() => {
        this.showSubmitFeedback = false;
      }, 3000);
      const s = adminService
        .deleteSection(this.form.surveyId, this.form.sectionId)
        .then(function(response) {
          if (response && CONSTANTS.HTTP.NO_CONTENT === response.status){
            console.log("Called delete with: " + me.form.sectionId);
            me.form.json = null;
          }
          
        })
        .catch(function(e) {
          console.error(e);
          throw e;
        });
    }
  },
  mounted() {
    const me = this;
    const claims = authTokenService.getClaims();
  }
};
</script>
